/* import BOQCosting from "./Components/BOQCosting";
function App() {
  return <BOQCosting />;
}

export default App; */
import { useEffect } from "react";
import BOQCosting from "./Components/BOQCosting";
import { initGA } from "./Services/Analytics";

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return <BOQCosting />;
}

export default App;